import axios from "axios"

export const RATE_LIMIT_MESSAGE = "Too many requests, please try again in a minute";

export const PACK_OUT_OF_STOCK = "PACK_OUT_OF_STOCK";
export const PACK_OUT_OF_STOCK_MESSAGE = "Selected pack is out of stock. Please choose another pack.";
export const ALL_PACKS_OUT_OF_STOCK_MESSAGE = "Sorry, this gift is currently out of stock.";

export function isRateLimited(err) {
    return err?.response?.status === 429;
}

// The user-details endpoint also returns 409 for a concurrent redeem, so branch on error_code.
export function isPackOutOfStock(err) {
    return err?.response?.data?.result?.error_code === PACK_OUT_OF_STOCK;
}

// in_stock can lag by a few seconds, so ids rejected by a submit are also treated as out of stock.
export function isPackInStock(pack, outOfStockPackIds = []) {
    return pack?.in_stock !== false && !outOfStockPackIds.includes(pack?.id);
}

// The template is needed on every page; fetch once per token and share the response.
const templateCache = new Map();

export function getTemplateData() {
    const url = new URLSearchParams(window.location.search);
    const token = url.get("token");

    if (!templateCache.has(token)) {
        const request = axios
            .get(`${process.env.REACT_APP_URL}/v4/customer/redemption/template?token=${token}`)
            .catch((err) => {
                templateCache.delete(token);
                throw err;
            });
        templateCache.set(token, request);
    }
    return templateCache.get(token);
}

// couponItems is needed on most pages; fetch once per token and share the response.
const couponItemsCache = new Map();

export function getCouponItems(token) {
    if (!couponItemsCache.has(token)) {
        const request = axios
            .get(`${process.env.REACT_APP_URL}/v4/customer/redemption/couponItems?token=${token}`)
            .catch((err) => {
                couponItemsCache.delete(token);
                throw err;
            });
        couponItemsCache.set(token, request);
    }
    return couponItemsCache.get(token);
}

export function clearCouponItemsCache(token) {
    couponItemsCache.delete(token);
}
